import { render, staticRenderFns } from "./BorderlessRating.vue?vue&type=template&id=f2334a9a"
import script from "./BorderlessRating.vue?vue&type=script&lang=js"
export * from "./BorderlessRating.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports